import MyAccountRegistered from "~/features/myAccount/profile/components/MyAccountRegistered/MyAccountRegistered";
import { userIsLoggedIn, userIsRegistered } from "~/domains/user/utils/roles";
import MyAccountB2B from "~/features/myAccount/profile/components/MyAccountB2B/MyAccountB2B";
import { type MyAccountDataJSP } from "~/features/myAccount/profile/myAccountTypes";
import { transformMyAccountData } from "~/features/myAccount/profile/myAccountDataTransformers";
import { useSelector } from "react-redux";
import { selectSavedAffiliate } from "~/domains/affiliate/redux/selectors";

export function createMyAccountPage(data: MyAccountDataJSP) {
  return <MyAccountContainer {...data} />;
}

export const MyAccountContainer = (dataDto: MyAccountDataJSP) => {
  const loggedIn = userIsLoggedIn();
  const registeredUser = userIsRegistered();
  const savedAffiliate = useSelector(selectSavedAffiliate);

  const data = transformMyAccountData(dataDto, savedAffiliate);

  return <>{loggedIn && <>{registeredUser ? <MyAccountRegistered data={data} /> : <MyAccountB2B data={data} />}</>}</>;
};
